export default "__VITE_ASSET__CP$MJ0vI__"